import { createGlobalStyle } from "styled-components";
import { css } from "styled-components";
import {b} from "./variables"
import styled from "styled-components";
import { Link } from "react-router-dom";

export const GlobalStyles = createGlobalStyle`
  *{
    margin: 0;
    padding: 0;
    box-sizing: inherit;
    -webkit-tap-highlight-color: transparent;
}

html {
    box-sizing: border-box;
    font-size: 62.5%;
    overflow-x: hidden;

    @media only screen and (max-width: 1200px){
        font-size: 58%;
    }
    @media only screen and (max-width: 480px){
        font-size: 56%;
    }
    @media only screen and (min-width: 1980px){
        font-size: 70%;
    }
}
body{
    font-family: 'Nunito Sans', sans-serif;
    font-weight: 400;
    line-height: 1.6;
    font-size: 1.6rem;
    background: #f8f9fb;
    color: #1e1e2d;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    overflow-x: hidden;
    width: 100%;
    min-height: 100vh;
    min-height: 100dvh;
    padding: env(safe-area-inset-top) env(safe-area-inset-right) env(safe-area-inset-bottom) env(safe-area-inset-left);
}

::-webkit-scrollbar {
    width: 6px;
}
::-webkit-scrollbar-track {
    background: transparent;
}
::-webkit-scrollbar-thumb {
    background: #d4d4d8;
    border-radius: 10px;
}
::-webkit-scrollbar-thumb:hover {
    background: #a1a1aa;
}

@media (hover: none) {
    ::-webkit-scrollbar {
        display: none;
    }
}
`;

export const MobileHide = css`
@media ${b.mobile} {
  display: none;
}`;

export const TabletHide = css`
@media ${b.tablet} {
  display: none;
}`;

export const FlxCenter = css`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const AbsCenter = css`
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  `;

  export const Button= styled.button`
  color: ${({fc})=>fc?({fc})=>fc:"white"};
  background: ${({bg})=>bg?({bg})=>bg:"#F7707D"};
  padding: ${({ptb})=>ptb?({ptb})=>ptb: "0.6rem"} ${({prl})=>prl?({prl})=>prl: "1.6rem"};
  font-size: ${({fs})=>fs?({fs})=>fs: "1.3rem"};
  width: ${({bw})=>bw?({bw})=>bw: "auto"};
  border-radius: ${(br)=>br?(br)=>br:"10px"}; 
  height: ${({bh})=>bh?({bh})=>bh: "auto"};
  font-weight: ${({fw})=>fw?({fw})=>fw: 500};
  border: ${({bb})=>bb?({bb})=>bb: "none"};
  box-shadow: none;
  cursor: pointer;
  font-family: 'Nunito Sans', sans-serif;
  transition: all 0.2s ease;

&:hover{
  color: ${({hfc})=>hfc?({hfc})=>hfc:"white"};
  opacity:0.9;
  transform: translateY(-1px);
}

&:active{
    transform: translateY(1px);
}
`

 export const EmptyContainer=styled.div`
 width: ${({w})=>w};
 height: ${({h})=>h};
 `

export const Container = styled.div`
margin: 0 auto;
padding: 0 1rem;

@media  ${b.mobile}{
    padding:0 0.3rem;
}
@media  ${b.tablet} {
    padding: 0 0.6rem;
}
`

export const IconContainer = styled.div`
`

export const MyNavLink=styled(Link)`
color:${({fc})=>fc?({fc})=>fc:"white"};
font-size: ${({fs})=>fs?({fs})=>fs: "1.2rem"}; 
text-decoration: none;
 padding-left: ${({pl})=>pl?({pl})=>pl: 0};
 padding-right: ${({pr})=>pr?({pr})=>pr: 0};
 padding-top: ${({pt})=>pt?({pt})=>pt: 0};
 padding-bottom: ${({pb})=>pb?({pb})=>pb: "0rem"};
 cursor: pointer;
 transition: color 0.2s ease;
&:hover {
  color: ${({hfc})=>hfc?({hfc})=>hfc:"#38d68b"};
  opacity:0.9;
} 
&:focus{
    color:  ${({afc})=>afc?({afc})=>afc:"white"};
};
&:active{
    color:${({aac})=>aac?({aac})=>aac:"white"};
};
@media ${b.mobile} {
        display: ${({d})=>d?({d})=>d : "block"};
}
`

export const TextContainer = styled.div`
display:flex;
flex-direction: column;
font-size: ${({fs})=>fs?({fs})=>fs: "1.2rem"} ;
font-weight:${({fw})=>fw?({fw})=>fw : "400"};
color:${({fc})=>fc?({fc})=>fc: "#1e1e2d"};
padding-left:${({pl})=>pl?({pl})=>pl: 0} ;
padding-right:${({pr})=>pr?({pr})=>pr: 0};
padding-top:${({pt})=>pt?({pt})=>pt: 0} ;
padding-bottom:${({pb})=>pb?({pb})=>pb: 0} ;
justify-content:${({jc})=>jc?({jc})=>jc: "left"};
align-items:${({ai})=>ai?({ai})=>ai: "top"};
&:hover{
color:${({hfc,fc})=>hfc?({hfc})=>hfc: fc};
}
`

export const FlxColumn = css`
  display: flex;
  flex-direction: column;
`
